import React from 'react'
import { Link } from 'gatsby'
import Stack from 'react-bootstrap/Stack'

export default function Breadcrumbs({ product }) {
    const { product_name, shop_categories } = product
    if(!product_name || !shop_categories.length) return
    return (
        <Stack direction='horizontal' gap={1} className='py-4'>
            <Link to='/' className='text-muted text-decoration-underline ff-primary small'>HOME</Link>
            <span>&gt;</span>
            <Link to={`/${shop_categories[0].slug}`} className='text-uppercase text-muted text-decoration-underline ff-primary small'>
                {shop_categories[0].name}
            </Link>
            <span>&gt;</span>
            <strong className='text-uppercase ff-primary small'>
                {product_name}
            </strong>
        </Stack>
    )
}